// @flow
import type { IconName } from '@ta/core-ui.icon';

export const getIconNameFromResultType = (type: string): ?IconName => {
  switch (type) {
    case 'HOTEL':
      return 'hotels';
    case 'EATERY':
      return 'restaurants';
    case 'ATTRACTION':
      return 'attractions';
    case 'UNIVERSITY':
      return 'classes-workshops';
    case 'TRAIN_STATION':
      return 'train';
    case 'AIRPORT':
      return 'flights';
    case 'THEME_PARK':
      return 'amusement-parks';
    case 'ACTIVITY':
      return 'activities';
    case 'SHOPPING':
      return 'shopping-bag-fill';
    case 'PORT':
      return 'ports';
    case 'GENERAL_HOSPITAL':
      return 'hospital';
    case 'FERRY':
      return 'cruises';
    case 'CORPORATION':
      return 'office';
    case 'BRAND':
      return null;
    case 'NEIGHBORHOOD':
      return 'neighborhoods-fill';
    case 'AIRLINE':
      return 'flights';
    case 'SHIP':
      return 'cruises';
    case 'CAR_RENTAL_OFFICE':
      return 'parking';
    case 'GEO':
    default:
      return 'map-pin-fill';
  }
};

const getIconFromResultType = (type: string): string =>
  (getIconNameFromResultType(type) || '': string);

export default getIconFromResultType;
